import { Box, Flex, Text } from '@chakra-ui/react'

const FilterBar = ({ left, right, summary }) => (
  <Box
    bg="bg.surface"
    borderRadius="lg"
    p={4}
    mb={6}
    border="1px solid"
    borderColor="border.subtle"
    shadow="sm"
  >
    <Flex
      align={{ base: 'stretch', md: 'center' }}
      justify="space-between"
      gap={4}
      direction={{ base: 'column', md: 'row' }}
    >
      <Flex gap={3} flexWrap="wrap" align="center">
        {left}
      </Flex>
      <Flex gap={3} flexWrap="wrap" align="center">
        {right}
      </Flex>
    </Flex>
    {summary && (
      <Text mt={3} fontSize="xs" color="text.muted">
        {summary}
      </Text>
    )}
  </Box>
)

export default FilterBar
